import { atom } from "jotai";

const getInitialToken = (): string => {
    if (typeof window === 'undefined') return ''
    try {
        return window.sessionStorage.getItem('accessToken') || ''
    } catch {
        return ''
    }
}

export const accessTokenAtom = atom<string>(getInitialToken())

/**
 * 앱(웹뷰 호스트)이 SEND_TOKEN 으로 답을 줬는지 여부.
 *
 * accessToken 이 비었다는 것만으로는 '앱이 로그아웃 상태'인지 '아직 못 받았는지'를 알 수 없다.
 * 앱은 토큰이 없어도 빈 값으로 SEND_TOKEN 을 보내므로, 이 값이 true 이고 토큰이 비어 있으면
 * 로그인하지 않은 상태로 확정할 수 있다. false 면 아직 기다리는 중이다.
 */
export const tokenAnsweredAtom = atom<boolean>(false)
